import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetCharactersQuery } from '@sorrem-client/ui/store';
import { getStoredCanonicalAccountId } from '@sorrem-client/ui/shared/auth-session';
import { findCurrentCharacter } from './use-current-character-id';
import { useSelectedCharacterId } from './use-selected-character-id';

/**
 * The current character's base body (`characterModelId`), or `undefined`
 * before the account's characters load (or when it has none). Picks the
 * character the way `useCurrentCharacterId` does, but reads only the cached
 * character list, so it is cheap enough for every item icon to call.
 */
export function useCurrentCharacterModelId(): string | undefined {
    const accountId = getStoredCanonicalAccountId();
    const { selectedCharacterId } = useSelectedCharacterId();
    const { data: characters } = useGetCharactersQuery(accountId ?? skipToken);
    return findCurrentCharacter(characters, selectedCharacterId)?.characterModelId;
}
